import { downloadApiFile } from '../../utils/downloadFile';

function slugEventTitle(title) {
  const slug = String(title || 'event')
    .trim()
    .replace(/[^\w\-]+/g, '_')
    .replace(/^_+|_+$/g, '');
  return slug || 'event';
}

export async function downloadConfirmedAttendees({ apiUrl, event, userId }) {
  const eventId = Number(event?.id);
  if (!eventId || !userId) {
    throw new Error('Missing event or user.');
  }
  if (!Number(event?.attendee_count || 0)) {
    throw new Error('No confirmed attendees yet.');
  }

  await downloadApiFile(
    `${apiUrl}/download_attendance_event_attendees.php?event_id=${eventId}&user_id=${userId}`,
    {
      fallbackName: `${slugEventTitle(event.title)}_confirmed_attendees.csv`,
      errorMessage: 'Could not download attendees.',
    }
  );
}
